<template>
  <div class="Card" :class="{ 'Card--shadow': type === 'shadow' }">
    <slot />
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: 'CardBase',
});

interface Props {
  type?: 'normal' | 'shadow';
}

withDefaults(defineProps<Props>(), {
  type: 'shadow',
});
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_forward.scss' as *;

.Card {
  background-color: $color-white-100;

  &--shadow {
    box-shadow: $service-shadow-mp;
  }
}
</style>
